/* global G */
import { curry } from 'lib/util'

/**
 * Open Chat Event Handler
 *
 * Grabs the chat url for the current equipment from the action state
 * and opens it in a new tab.
 *
 * @param {Gaia.AppModule.Spec} module          app module
 * @param {Gaia.AppModule.Action} component     action component
 * @param {Gaia.AppModule.EventHandler} event   the event that triggered this handler
 * @returns {Promise<void>}
 */
const openChat = async (module, component, event) => {
  const moduleState = module[G.STATE]
  const actionState = moduleState[G.ACTION][G.STATE]

  const { chatUrl = null } = actionState

  chatUrl && await module[G.ADAPTER][G.ROUTER].newTab({ url: chatUrl })
}

export default curry(openChat)
